module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-Students-0008c859cc9f2a0685612cae01aa9990.svg";